'use client'

import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { QueryKey } from 'shared/api'

import { getPackingOptions } from '../../../api'
import { PackingOption } from '../../../types'

interface UseQueryPackingOptionsProps {
  token: string | undefined
}
export default function useQueryPackingOptions({
  token
}: UseQueryPackingOptionsProps): UseQueryResult<PackingOption[]> {
  return useQuery<PackingOption[]>({
    queryKey: [QueryKey.packingOptions, token],

    queryFn: () => {
      return getPackingOptions(token)
    }
  })
}
